import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';

import {
  FlightOperationNotificationClient,
  FlightOperationNotification,
  FlightOperationNotificationDTO,
  ProblemDetails,
} from '../../clients';

import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightOperationNotificationClient = new FlightOperationNotificationClient(apiBaseUrl);

function useUpdateFlightOperationNotification() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<FlightOperationNotificationDTO, ProblemDetails, FlightOperationNotification>({
    mutationKey: [queryKeys.FlightOperationNotification.Update],
    mutationFn: (report: FlightOperationNotification) => flightOperationNotificationClient.update(report),
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Form data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useUpdateFlightOperationNotification;
